export const sideBanner = () => {
  // NOTE: The height of the side banner needs to align with the top of the header heading text.
  //       This script calculates side banner (vertical) positions compared to header headding text.
  //       Should only work in desktop / large tablet view.

  // Reposition when the browser is first loaded.
  repositionBanner();

  // Resize as the user changes / update the browser width.
  window.onresize = repositionBanner;

  function repositionBanner() {
    const sideBannerContainer = document.querySelector(
      ".side-banner-container"
    );

    if (document.querySelector(".side-banner-container")) {
      if (window.innerWidth > 768 && document.querySelector(".side-banner-hero-header")) {
        const heroHeight = document.querySelector(".side-banner-hero-header")
          .clientHeight;
        sideBannerContainer.style.marginTop = -heroHeight + 50 + "px";
      } else {
        sideBannerContainer.style.marginTop = "0px";
      }
    }
  }
};
